import React from "react";
import PropTypes from "prop-types";
import isApp from "shared/util/isApp";
import { withRouter } from "react-router-dom";
import Str from "shared/components/Str";
import Link from "shared/components/Link";
import AppPhoneCommand from "shared/util/AppPhoneCommand";
import { hasNativeLanding } from "shared/util/AppFeatures";

import { FIELDS, URLS } from "apps/signup/util/constants";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

const Header = ({ currentField, setCurrentField }) => {
	const buttonClasses = "signup2017-header-previous";
	const buttonContent = <i className="okicon i-arrow-left" />;

	const onBack = () => setCurrentField(FIELDS.EMAIL);

	const usePopActivityForBackClick = isApp() && hasNativeLanding();

	return (
		<div className="signup2017-header">
			{currentField === FIELDS.REGISTRATION &&
				<span
					className={buttonClasses}
					onClick={onBack}
					role="button"
					tabIndex="-1"
				>
					{buttonContent}
				</span>
			}

			{currentField !== FIELDS.REGISTRATION && usePopActivityForBackClick && (
				<button
					type="button"
					className={buttonClasses}
					onClick={() => AppPhoneCommand("popActivity")}
				>
					{buttonContent}
				</button>
			)}

			{currentField !== FIELDS.REGISTRATION && !usePopActivityForBackClick && (
				<Link
					className={buttonClasses}
					to={URLS.SPLASH}
				>
					{buttonContent}
				</Link>
			)}

			<span className="signup2017-header-text">
				<Str>About you</Str>
			</span>
		</div>
	);
};

Header.propTypes = {
	currentField: PropTypes.string.isRequired,
	setCurrentField: PropTypes.func.isRequired,
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/apps/signup/components/Header/index.jsx